import type { RootState } from '@/store/root-reducer';

const selectMySchoolsState = (state: RootState) => state.mySchools;

export const selectRows = (state: RootState) => selectMySchoolsState(state).rows;
export const selectTotal = (state: RootState) => selectMySchoolsState(state).total;
export const selectLoading = (state: RootState) => selectMySchoolsState(state).loading;
export const selectError = (state: RootState) => selectMySchoolsState(state).error;
export const selectPage = (state: RootState) => selectMySchoolsState(state).page;
export const selectPageSize = (state: RootState) => selectMySchoolsState(state).pageSize;
